import { UseSubscriptionProductsStore } from '../store';

export const productDetails: UseSubscriptionProductsStore[] = [
  [
    // core
    {
      product_id: '1',
      type: 'Lite',
      description: 'For Smaller Firms',
      price: 320,
      tier_id: '1',
      users: {
        max: '3',
      },
      body: [
        'Leap years ahead.',
        'Monetise your advice.',
        'Best practice everything.',
      ],
      benefits: [
        {
          label: 'Marketing',
          details: ['12 Month Marketing Plan'],
        },
        {
          label: 'Engagement',
          details: [
            'Engagement letters',
            '40+ service descriptions',
            'Pricing recommendations',
          ],
        },
        {
          label: 'Production/Delivery',
          details: [
            'New client set up system',
            'Annual accounts system',
            'Annual tax return system',
            'Company tax return checklist',
            'Company accounts checklist',
            'Individual tax return checklist',
            'BAS workpapers',
            'FBT template',
            'Trust distribution templates',
            'Dividend statement templates',
          ],
        },
        {
          label: 'Completion',
          details: ['PDF editor for mail merge', 'PDF doc packs'],
        },
      ],
    },
    {
      product_id: '1',
      type: 'Pro',
      description: 'For Medium Firms',
      price: 760,
      tier_id: '2',
      users: {
        min: '4',
        max: '15',
      },
      body: [
        'All the benefits of Core LITE, plus:',
        'Service Plan CRM.',
        'Structure advice report.',
        'Directly edit and send.',
      ],
      benefits: [
        {
          label: 'CUSTOM APPS',
          details: [
            'Structure Advice app',
            'CGT Reduce app',
            'Dividend Statements app',
            'Trust Distributions app',
            'FBT Report & Declare app',
            'Letter Templates app',
          ],
        },
        {
          label: 'TOOLS & SYSTEMS',
          details: [
            'HR tools',
            'CRM (Service Plan & Potential)',
            'Wills & Estates system',
            'Client Deletion system',
            'Cash Flow Advisory system',
            'Pricing system',
            'Business Rebound system',
            'Debtor Management system',
            'Business Valuation Report system',
            'New Client Setup system',
            'Fee Quote Calculator',
          ],
        },
      ],
    },
    {
      product_id: '1',
      type: 'Enterprise',
      description: 'For Larger Firms',
      price: 76,
      tier_id: '3',
      users: {
        max: '16+',
      },
      body: [
        'All the benefits of Core LITE, plus:',
        'Service Plan CRM.',
        'Structure advice report.',
        'Directly edit and send.',
      ],
      benefits: [
        {
          label: 'CUSTOM APPS',
          details: [
            'Structure Advice app',
            'CGT Reduce app',
            'Dividend Statements app',
            'Trust Distributions app',
            'FBT Report & Declare app',
            'Letter Templates app',
          ],
        },
        {
          label: 'TOOLS & SYSTEMS',
          details: [
            'HR tools',
            'CRM (Service Plan & Potential)',
            'Wills & Estates system',
            'Client Deletion system',
            'Cash Flow Advisory system',
            'Pricing system',
            'Business Rebound system',
            'Debtor Management system',
            'Business Valuation Report system',
            'New Client Setup system',
            'Fee Quote Calculator',
          ],
        },
        {
          label: 'Support and Onboarding',
          details: [
            'Customised support',
            'In-house training',
            'Features on demand',
          ],
        },
      ],
    },
  ],
  [
    // progress
    {
      product_id: '2',
      type: 'Lite',
      description: 'For Smaller Firms',
      price: 320,
      tier_id: '7',
      users: {
        max: '15',
      },
      body: [
        'Leap years ahead.',
        'Monetise your advice.',
        'Best practice everything.',
      ],
      benefits: [
        {
          label: '',
          details: [
            'One-touch reporting in seconds',
            'Group position reports in summary',
            'Tax position reports',
            'Payroll and business performance',
            'Annual meeting agendas',
            'ATO benchmarking data integrated',
            'Group average tax calculations',
            'Rank clients to spark conversation',
          ],
        },
      ],
    },
    {
      product_id: '2',
      type: 'Enterprise',
      description: 'For Larger Firms',
      price: 32,
      tier_id: '3',
      users: {
        max: '16+',
      },
      body: [
        'Leap years ahead.',
        'Monetise your advice.',
        'Best practice everything.',
      ],
      benefits: [
        {
          label: '',
          details: [
            'One-touch reporting in seconds',
            'Group position reports in summary',
            'Tax position reports',
            'Payroll and business performance',
            'Annual meeting agendas',
            'ATO benchmarking data integrated',
            'Group average tax calculations',
            'Rank clients to spark conversation',
          ],
        },
        {
          label: 'Support and Onboarding',
          details: [
            'Customised support',
            'In-house training',
            'Features on demand',
          ],
        },
      ],
    },
  ],
  [
    // taxplan
    {
      product_id: '3',
      type: 'Pro',
      description: 'For Smaller Firms',
      price: 540,
      tier_id: '1',
      users: {
        max: '10',
      },
      body: [
        'Everything you need to get started, plus:',
        'Advanced client reports.',
        'Tax flow reports.',
        'Show strategy savings.',
      ],
      benefits: [
        {
          label: '',
          details: [
            '90 pre-written tax strategy descriptions in client friendly language',
            'Show strategy savings',
            'Tax Calculation Workpaper',
            'Compare your scenarios and show your clients the dollars saved in your recommended strategy',
            '17 x information-only pieces of value',
            'Standardised tax planning template',
            'Unlimited distribution scenarios',
            'Unlimited Scenarios',
            'Primary producer strategies',
            'Integration with XPM and Xero Tax',
            'Annual budget and stimulus updates',
            'Client advice sign off form',
          ],
        },
        {
          label: 'REPORTS',
          details: [
            'TaxPlan workbook calculation report in Excel',
            'Advanced TaxPlan client report',
            'Tax flow report - Automated 18 month PAYG projections',
            'Scenario comparison report',
          ],
        },
        {
          label: 'MARKETING',
          details: ['Tax planning marketing system'],
        },
        {
          label: 'SUPPORT',
          details: ['One annual training session for your practice'],
        },
      ],
    },
    {
      product_id: '3',
      type: 'Advanced',
      description: 'For Larger Firms',
      price: 760,
      tier_id: '8',
      users: {
        max: '15',
      },
      body: ['All of the features of TaxPlan Pro, plus:'],
      benefits: [
        {
          label: 'REPORTS',
          details: [
            'Professional Firm Profit Advice',
            'Trust Distribution Options Advice',
            'Div7A Advice (Coming Soon)',
          ],
        },
        {
          label: 'MARKETING',
          details: [
            'Professional Firm Profit Marketing System',
            'Trust Distribution Advice Marketing System',
          ],
        },
        {
          label: 'SUPPORT',
          details: ['One annual training session for your practice'],
        },
      ],
    },
    {
      product_id: '3',
      type: 'Enterprise Pro',
      description: 'For Larger Firms',
      price: 54,
      tier_id: '9',
      users: {
        max: '16+',
      },
      body: ['Everything in PRO, plus:'],
      benefits: [
        {
          label: 'SUPPORT',
          details: [
            'Customised onboarding',
            'Custom Training videos',
            'Learning and development strategy for team training',
          ],
        },
      ],
    },
    {
      product_id: '3',
      type: 'Enterprise Advanced',
      description: 'Larger Firms',
      price: 76,
      tier_id: '2',
      users: {
        max: '16+',
      },
      body: ['Everything in ADVANCED, plus:'],
      benefits: [
        {
          label: 'SUPPORT',
          details: [
            'Customised onboarding',
            'Custom Training videos',
            'Learning and development strategy for team training',
          ],
        },
      ],
    },
  ],
  [
    // engage
    {
      product_id: '4',
      type: 'Lite',
      description: 'For Any Size Firms',
      price: 110,
      tier_id: '1',
      users: {
        max: '3',
      },
      body: [
        'Protect and save.',
        'Get fees funded.',
        'Integrate BAS services.',
      ],
      benefits: [
        {
          label: '',
          details: [
            '50+ service descriptions',
            'Based on CA/IPA/CPA',
            'Automated ethical letters',
            'Value plan price methodology',
            'Upfront/Monthly/Hourly rates',
            'Unlimited entities',
            'Go Cardless direct debits',
            'Email as PDF or Digital Signatures',
          ],
        },
      ],
    },
    {
      product_id: '4',
      type: 'Enterprise',
      description: 'For Any Size Firms',
      price: 37,
      tier_id: '6',
      users: {
        max: '3+',
      },
      body: ['Protect and save.', 'Create rapport.', 'Manage scope.'],
      benefits: [
        {
          label: '',
          details: [
            '50+ service descriptions',
            'Based on CA/IPA/CPA',
            'Automated ethical letters',
            'Value plan price methodology',
            'Upfront/Monthly/Hourly rates',
            'Unlimited entities',
            'Go Cardless direct debits',
            'Email as PDF or Digital Signatures',
          ],
        },
      ],
    },
  ],
  [
    // protect
    {
      product_id: '6',
      type: 'Pro',
      description: 'For Smaller Firms',
      price: 500,
      tier_id: '1',
      users: {
        max: '10',
      },
      body: ['Includes up to 25 + 1 Client Advice Reports'],
      benefits: [
        {
          label: 'Personalised Client Advice Report',
          details: [
            'Customisable Cover Letter',
            'Overview of Asset Protection',
            "Client's Objectives and Concerns",
            'Wealth Transfer and Asset Protection Plans',
            'Explanation of Key Concepts',
            'Recommendations and Associated Fees',
            'Strategy Allocation',
          ],
        },
        {
          label: 'Report Generation & Management',
          details: [
            'Strategy Guidelines in Reports',
            'Step-by-Step Report Wizard',
            'Direct Strategy Assignment',
            'Saved Report Modification Capability',
            'Fee Customisation',
          ],
        },
        {
          label: 'Client and Group Management',
          details: [
            'Client Group Manager',
            'Import from XPM',
            'Include Assets and Liabilities',
          ],
        },
        {
          label: 'Comprehensive Resources',
          details: [
            'Service Delivery System',
            'VPP Client Service Offer Email',
            'Structuring Advice for Strategies',
          ],
        },
        {
          label: 'Presentation and Communication',
          details: ['‘Client View’ Presentation Mode', 'Export to MS Word'],
        },
      ],
    },
  ],
];
